import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { Table } from '../pages/table/table';
import { Custom } from '../pages/custom/custom';
import { CustomDetail } from '../pages/custom/customdetail/customdetail';
import { List } from "../pages/list/list";
import { DetailPopoverMenu } from "../pages/detailPopoverMenu/detailPopoverMenu";
import { Detail } from "../pages/detail/detail";
import { LiniendiagrammPage } from "../pages/liniendiagramm/liniendiagramm";
import { IFrame } from "../pages/iframe/iframe";
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HttpModule } from "@angular/http";
import { ChartModule } from 'angular2-highcharts';
import { HighchartsStatic } from 'angular2-highcharts/dist/HighchartsService';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { SafeHtml } from "../pipes/safeHTML";
import { SafeStyle } from "../pipes/safeStyle";
import { HeaderComponent } from "../components/header/header";
import { ContactComponent } from "../components/contact/contact";
import { AnimatesDirective, AnimationService } from "css-animator";
import { EbsWebServiceGlobals } from "../services/ebsWebServiceGlobals";
import { EbsWebService } from "../services/ebsWebService";
import { GridBoxComponent } from "../components/grid-box/grid-box";
import { EbsComponentService } from "../services/ebsComponentService";
import { GridBoxPage } from "../pages/grid-box/grid-box";
import { LoadImageFromStorage } from "../pipes/loadImageFromStorage";
import { DetectImages } from "../pipes/detectImages";
import { PdfViewerPage } from "../pages/pdf-viewer/pdf-viewer";
import { ScannerPage } from "../pages/scanner/scanner";
import { CustomFooterPage } from "../components/custom-footer/custom-footer";
import { CustomHeaderPage } from "../components/custom-header/custom-header";
import { CustomBodyPage } from "../components/custom-body/custom-body";
import { NoticesPage } from "../components/notices/notices";
import { LoginPage } from "../pages/login/login";
import { DocumentViewer } from "@ionic-native/document-viewer";
import { HttpClientModule } from "@angular/common/http";
import { FilePickerPopOver } from "../popovers/filepicker/filepicker";
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { IOSFilePicker } from '@ionic-native/file-picker';
import { File } from '@ionic-native/file';
import { Camera, CameraOptions } from '@ionic-native/camera';
import {InputPage} from "../components/inputs/inputs";
import {CheckForFullWidth} from "../pipes/checkForFullWidth";
import {Signature} from "../pages/signature/signature";
import { SignaturePadModule } from 'angular2-signaturepad';
import {IonicImageViewerModule} from "ionic-img-viewer";

declare var require: any;
export function highchartsFactory() {
  return require('highcharts');
}

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    Table,
    List,
    DetailPopoverMenu,
    Detail,
    LiniendiagrammPage,
    IFrame,
    PdfViewerComponent,
    Custom,
    CustomDetail,
    SafeHtml,
    LoadImageFromStorage,
    SafeStyle,
    HeaderComponent,
    AnimatesDirective,
    GridBoxComponent,
    GridBoxPage,
    ContactComponent,
    DetectImages,
    PdfViewerPage,
    ScannerPage,
    CustomFooterPage,
    CustomHeaderPage,
    CustomBodyPage,
    NoticesPage,
    LoginPage,
    Signature,
    FilePickerPopOver,
    InputPage,
    CheckForFullWidth
  ],
  imports: [
    BrowserModule,
    HttpModule,
    SignaturePadModule,
    ChartModule,
    HttpClientModule,
    IonicImageViewerModule,
    IonicStorageModule.forRoot(),
    IonicModule.forRoot(MyApp, {
      platforms: {
        ios: {
          statusbarPadding: true
        }
      },
      mode: 'ios',
      backButtonText: '',
      iconMode: 'ios',
      modalEnter: 'modal-slide-in',
      modalLeave: 'modal-slide-out',
      tabsPlacement: 'bottom',
      pageTransition: 'ios-transition'
    }),

  ],
  bootstrap: [IonicApp],
  schemas: [
    //NO_ERRORS_SCHEMA
  ],
  entryComponents: [
    MyApp,
    HomePage,
    Table,
    List,
    DetailPopoverMenu,
    Detail,
    LiniendiagrammPage,
    IFrame,
    PdfViewerComponent,
    Custom,
    CustomDetail,
    GridBoxComponent,
    GridBoxPage,
    ContactComponent,
    PdfViewerPage,
    ScannerPage,
    CustomFooterPage,
    CustomBodyPage,
    LoginPage,
    Signature,
    FilePickerPopOver
  ],
  providers: [
    StatusBar,
    SplashScreen,
    AnimationService,
    EbsWebServiceGlobals,
    EbsWebService,
    EbsComponentService,
    DocumentViewer,
    BarcodeScanner,
    IOSFilePicker,
    File,
    Camera,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    {provide: HighchartsStatic, useFactory: highchartsFactory}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts